module.exports = __webpack_public_path__ + "fonts/Inter-600-cyrillic-ext36.251d36f.woff2";